import { dscvrIcApi } from '@/shared/api';
import { useMutation } from '@tanstack/vue-query';

export const useSetUserCoverPhotoMutation = () => {
  return useMutation({
    mutationKey: ['set-user-cover-photo-mutation'],
    mutationFn: dscvrIcApi.userSettings.setCoverPhoto,
  });
};
